/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Whtr_Band_IncreasedInputs */

const en_us2_body_assessment_whtr_band_increased = /** @type {(inputs: Body_Assessment_Whtr_Band_IncreasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Increased risk`)
};

const pt_br2_body_assessment_whtr_band_increased = /** @type {(inputs: Body_Assessment_Whtr_Band_IncreasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risco aumentado`)
};

const es_419_body_assessment_whtr_band_increased = /** @type {(inputs: Body_Assessment_Whtr_Band_IncreasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riesgo aumentado`)
};

const pt_pt2_body_assessment_whtr_band_increased = /** @type {(inputs: Body_Assessment_Whtr_Band_IncreasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risco aumentado`)
};

const fr_fr2_body_assessment_whtr_band_increased = /** @type {(inputs: Body_Assessment_Whtr_Band_IncreasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risque accru`)
};

const de_de2_body_assessment_whtr_band_increased = /** @type {(inputs: Body_Assessment_Whtr_Band_IncreasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erhöhtes Risiko`)
};

const it_it2_body_assessment_whtr_band_increased = /** @type {(inputs: Body_Assessment_Whtr_Band_IncreasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rischio aumentato`)
};

/**
* | output |
* | --- |
* | "Increased risk" |
*
* @param {Body_Assessment_Whtr_Band_IncreasedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_whtr_band_increased = /** @type {((inputs?: Body_Assessment_Whtr_Band_IncreasedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Whtr_Band_IncreasedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_whtr_band_increased(inputs)
	if (locale === "es-419") return es_419_body_assessment_whtr_band_increased(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_whtr_band_increased(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_whtr_band_increased(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_whtr_band_increased(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_whtr_band_increased(inputs)
	return en_us2_body_assessment_whtr_band_increased(inputs)
});
export { body_assessment_whtr_band_increased as "body-assessment.whtr_band.increased" }